//------------- REACT IMPORT ---------------//
import React from "react";
//---------- FONTAWESOME IMPORT ------------//
import { faCalendar, faAlternateCalendar, faCheckCircle, faCircle, faCircleCheck, faCalendarMinus, faEdit, faTrashCan, faCommentDots } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
//-------- BOOTSTRAP ITEMS IMPORT ----------//
import { Accordion, Button, Card, Col, Container, Image, OverlayTrigger, Row, Table, Tooltip } from "react-bootstrap";
import PaginationComponent from "../../CommanComponents/Pagination";
import { CalendarBlack } from "../../../../assets/images";

const MedicineUpdate = () => {
    return (
        <>
            <div className="medicine_update_screen">
                <Row>
                    <Col xxl={12} xl={12} lg={12} md={12} sm={12} xs={12}>
                        <div className="medicine_main_area">
                            <div className="date_main">
                                <div className="left_area">
                                    <p>Date : 26 May, 2023</p>
                                </div>
                                <div className="right_area">
                                    <div className="img_area">
                                        <Image src={CalendarBlack} alt="..." />
                                    </div>
                                </div>
                            </div>
                            <div className="accordion_area">
                                <Accordion defaultActiveKey="0">
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header>Morning - Before Breakfast</Accordion.Header>
                                        <Accordion.Body>
                                            <div className="inner_body_area">
                                                <div className="top_area">
                                                    <div className="top_left_area">
                                                        <div className="text_area">
                                                            <p>Thyronorom, Thyroxine</p>
                                                            <div className="label"> 0.5ml</div>
                                                        </div>
                                                    </div>
                                                    <div className="top_right_area">
                                                        <div className="main_area">
                                                            <div className="icon_area">
                                                                <FontAwesomeIcon className="icon_style" icon={faEdit} />
                                                                <FontAwesomeIcon className="icon_style" icon={faTrashCan} />
                                                                <FontAwesomeIcon className="icon_style" icon={faCommentDots} />
                                                            </div>
                                                            <div>
                                                                <a href="javascript:;" className="pending">Pending</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="mid_content_area">
                                                    <div className="left_con_area">
                                                        <ul>
                                                            <li>Route : Oral</li>
                                                            <li>Salt: Salt Name</li>
                                                            {/* <li>Last Given By : <span>Julia ( Nurse )</span></li>
                                                            <li>Date & Time : 12 May, 2023 10:00AM</li> */}
                                                        </ul>
                                                    </div>
                                                    <div className="right_con_area">
                                                        <a href="javascript:;">Complete</a>
                                                    </div>
                                                </div>
                                                <div className="bottom_area">
                                                    <div className="left_area">
                                                        <p>Assigned by : <span>Olivia Lopez ( Doctor )</span></p>
                                                    </div>
                                                    <div className="right_area">
                                                        <p>Assigned on : 12 May, 2023 08:13 AM</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                    <Accordion.Item eventKey="1">
                                        <Accordion.Header>Morning - After Breakfast</Accordion.Header>
                                        <Accordion.Body>
                                            <div className="inner_body_area">
                                                <div className="top_area">
                                                    <div className="top_left_area">
                                                        <div className="text_area">
                                                            <p>Thyronorom, Thyroxine</p>
                                                            <div className="label"> 0.5ml</div>
                                                        </div>
                                                    </div>
                                                    <div className="top_right_area">
                                                        <div className="main_area">
                                                            <div className="icon_area">
                                                                <FontAwesomeIcon className="icon_style" icon={faEdit} />
                                                                <FontAwesomeIcon className="icon_style" icon={faTrashCan} />
                                                                <FontAwesomeIcon className="icon_style" icon={faCommentDots} />
                                                            </div>
                                                            <div>
                                                                <a href="javascript:;" className="complete">Complete</a>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="mid_content_area remove_btn">
                                                    <div className="left_con_area">
                                                        <ul>
                                                            <li>Route : Oral</li>
                                                            <li>Salt: Salt Name</li>
                                                            <li>Last Given By : <span>Julia ( Nurse )</span></li>
                                                            <li>Date & Time : 12 May, 2023 10:00AM</li>
                                                        </ul>
                                                    </div>
                                                    {/* <div className="right_con_area">
                                                        <a href="javascript:;">Complete</a>
                                                    </div> */}
                                                </div>
                                                <div className="bottom_area">
                                                    <div className="left_area">
                                                        <p>Assigned by : <span>Olivia Lopez ( Doctor )</span></p>
                                                    </div>
                                                    <div className="right_area">
                                                        <p>Assigned on : 12 May, 2023 08:13 AM</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                            </div>
                        </div>
                    </Col>
                </Row>
            </div>
            <PaginationComponent />
        </>
    )
}

export default MedicineUpdate;